import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export type WeightUnit = "g" | "kg" | "lb" | "oz";
export type DimensionUnit = "cm" | "in";

interface UnitSelectorProps {
  type: "weight" | "dimension";
  value: string;
  onChange: (value: string) => void;
}

export function UnitSelector({ type, value, onChange }: UnitSelectorProps) {
  if (type === "weight") {
    return (
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-[70px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="g">g</SelectItem>
          <SelectItem value="kg">kg</SelectItem>
          <SelectItem value="lb">lb</SelectItem>
          <SelectItem value="oz">oz</SelectItem>
        </SelectContent>
      </Select>
    );
  }

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[70px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="cm">cm</SelectItem>
        <SelectItem value="in">in</SelectItem>
      </SelectContent>
    </Select>
  );
}
